import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPost } from "../../../config/fetchWrapper";

export const manageEntitiesFilter = createAsyncThunk(
  "manageEntitiesFilter",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.manageEntitiesFilter, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const manageEntitiesFilterSlice = createSlice({
  name: "manageEntitiesFilter",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    manageEntitiesFilterReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [manageEntitiesFilter.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = false;
    },
    [manageEntitiesFilter.pending]: (state) => {
      state.isLoading = true;
      state.data = false;
      state.error = null;
    },
    [manageEntitiesFilter.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const { manageEntitiesFilterReset } = manageEntitiesFilterSlice.actions;
